import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import reportWebVitals from './reportWebVitals';
import { MyContextProvider } from './context/global/Context';
import Router from './navigation/router';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MyContextProvider>
      <Router />
    </MyContextProvider>
  </React.StrictMode>
);

reportWebVitals();
